import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  setLoading,
  setPortfolioList,
  setPortfolioListPage,
  setLoadingCount
} from "../actions";
import { getPortfolioList } from "../api/handler";
import { GET_PORTFOLIO_LIST } from "../actions/types";

function* handleLoadPortfolioList(args) {
  yield put(setLoading(true));
  try {
    const response = yield call(getPortfolioList, args.param);
    if (response.status === 200) {
      yield put(setPortfolioList(response.data.data));
      yield put(
        setPortfolioListPage({
          totalRecords: response.data.totalRecords,
          totalPages: response.data.totalPages
        })
      );
    }
  } catch (e) {
    console.warn(e);
  }
  yield put(setLoading(false));
  yield put(setLoadingCount(1));
}

export default function* portfolioSaga() {
  yield all([takeLatest(GET_PORTFOLIO_LIST, handleLoadPortfolioList)]);
}
